import AddTag from '../views/Task/AddTag';
import TagList from '../views/Task/TagList';
import AddTask from '../views/Task/AddTask';
import TaskList from '../views/Task/TaskList';
import AddTaskProgress from '../views/Task/AddTaskProgress';
import TaskProgressList from '../views/Task/TaskProgressList';
import TaskDetail from '../views/Task/TaskDetail';

import AddReport from '../views/Task/AddReport';
import ReportList from '../views/Task/ReportList';

import AddArticle from '../views/Task/AddArticle';
import ArticleList from '../views/Task/ArticleList';

import AddDirect from '../views/Task/AddDirect';
import DirectList from '../views/Task/DirectList';

let Task = [
  {
    path: 'AddTag',
    name: '添加标引',
    component: AddTag
  },
  {
    path: 'TagList',
    name: '标引列表',
    component: TagList
  },
  {
    path: 'AddTask',
    name: '添加任务',
    component: AddTask
  },
  {
    path: 'TaskList',
    name: '任务列表',
    component: TaskList
  },
  {
    path: 'AddTaskProgress',
    name: '上报我的任务进度',
    component: AddTaskProgress
  },
  {
    path: 'TaskProgressList',
    name: '我的任务执行记录',
    component: TaskProgressList
  },
  {
    path: 'TaskDetail',
    name: '任务详情',
    component: TaskDetail
  }
];

let Report = [
  {
    path: 'AddReport',
    name: '添加报题',
    component: AddReport
  },
  {
    path: 'ReportList',
    name: '报题列表',
    component: ReportList
  }
];

let Draft = [
  {
    path: 'AddArticle',
    name: '添加任务稿件',
    component: AddArticle
  },
  {
    path: 'ArticleList',
    name: '稿件列表',
    component: ArticleList
  }
];

let Direct = [
  {
    path: 'AddDirect',
    name: '下发指令',
    component: AddDirect
  },
  {
    path: 'DirectList',
    name: '指令列表',
    component: DirectList
  }
];
export { Task, Report, Draft, Direct };
